import React, { useEffect, useState } from "react"
import { useSelector, useDispatch } from "react-redux"

import { IDLE, PENDING } from "const"
import { MtAccountUserGroup, MtGroup } from "server/models"
import { StateType } from "client/utils"
import {
    StoreType,
    UserGroupProps,
    GroupFilters,

    SortGroups,
    AddAccountUserGroup,

    closeModal,
    setNotAssignedUserGroupIds,
    setNotAssignedUserGroupSort,
    setNotAssignedUserGroupFilters,
    setNotAssignedUserGroupSelected,
    setUserGroupReloadList,
} from "client/store"
import {
    Container,
    PageHeader,
    PageTitle,
    PageContent,
    PageForm,
    Button,
    TableSearchWrapper,
    Table,
    SortRows,
    SpinnerIcon,
} from "client/components"

import GroupSearch from "client/pages/search/groupSearch"
import Columns from "./columns"

let isMounted: boolean

const NotAssignedUserGroups = ({
    accountId = 0,
    userId = 0,
}: UserGroupProps) => {
    const accountGroups = useSelector((state: StoreType) => state.group.accountGroups)
    const userGroupList = useSelector((state: StoreType) => state.userGroup.userGroupList)

    const groupIds = useSelector((state: StoreType) => state.userGroup.notAssignedGroups.groupIds)
    const sortColumn = useSelector((state: StoreType) => state.userGroup.notAssignedGroups.sortColumn)
    const sortOrder = useSelector((state: StoreType) => state.userGroup.notAssignedGroups.sortOrder)
    const filters = useSelector((state: StoreType) => state.userGroup.notAssignedGroups.filters)
    const selected = useSelector((state: StoreType) => state.userGroup.notAssignedGroups.selected)

    const lang = useSelector((state: StoreType) => state.system.lang)
    const dispatch = useDispatch()

    const [saveState, setSaveState] = useState<StateType>(IDLE)

    useEffect(() => {
        isMounted = true
        return () => {
            isMounted = false
        }
    }, [])

    useEffect(() => {
        const sortedGroupIds = SortGroups(Object.values(accountGroups), sortColumn, sortOrder, filters)
        const userGroupIds = userGroupList && userGroupList[userId] ? userGroupList[userId] : []

        const sortedNotAssigned = sortedGroupIds.filter((groupId) => !userGroupIds.includes(groupId))
        dispatch(setNotAssignedUserGroupIds(sortedNotAssigned))
    }, [userGroupList, sortColumn, sortOrder, filters])

    const onSort: SortRows = (column: keyof MtGroup, order) => {
        dispatch(setNotAssignedUserGroupSort(column, order))
    }

    const onFilter = (newFilters: GroupFilters) => {
        dispatch(setNotAssignedUserGroupFilters(newFilters))
        dispatch(setNotAssignedUserGroupSelected(null))
    }

    const addUserGroups = () => {
        setSaveState(PENDING)

        const userGroups: MtAccountUserGroup[] = []
        selected.forEach((groupId) => {
            userGroups.push({
                userId,
                accountId,
                groupId,
            })
        })

        AddAccountUserGroup(userGroups).then(() => {
            if (isMounted) {
                setSaveState(IDLE)
                dispatch(closeModal())
            }
            dispatch(setNotAssignedUserGroupSelected(null))

            dispatch(setUserGroupReloadList(false))
            setTimeout(() => {
                dispatch(setUserGroupReloadList(true))
            }, 0)
        })
    }

    const columns = Columns()

    return (
        <Container>
            <PageHeader>
                <PageTitle>{lang.selectGroup_s}</PageTitle>
            </PageHeader>
            <PageContent>
                <TableSearchWrapper>
                    <GroupSearch
                        id="notAssignedUserGroups"
                        filters={filters}
                        onFilter={onFilter}
                    />
                </TableSearchWrapper>
                <Table
                    columns={columns}
                    dataList={accountGroups}
                    dataIds={groupIds}
                    selectedIds={selected}
                    sortColumn={sortColumn}
                    sortOrder={sortOrder}
                    rowSize="sm"
                    showPagination
                    onSort={onSort}
                />
                <PageForm>
                    <Button variant="success" onClick={addUserGroups}>
                        {saveState === PENDING ? <SpinnerIcon /> : lang.select}
                    </Button>
                </PageForm>
            </PageContent>
        </Container>
    )
}
export default NotAssignedUserGroups
